import { resolveAuthConfig } from './auth-config';

const configuredApiBaseUrl = import.meta.env.API_BASE_URL?.trim() || null;
const isProduction = import.meta.env.PROD;

function getAppOrigin(): string {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }

  return isProduction
    ? 'https://thankful-cliff-009f9180f.2.azurestaticapps.net'
    : 'http://localhost:4200';
}

const appOrigin = getAppOrigin();

export const environment = {
  production: isProduction,
  apiPort: isProduction ? 443 : 5100,
  useMocks: false,
  apiBaseUrl: configuredApiBaseUrl,

  // Auth configuration - CIAM (External ID)
  auth: {
    ...resolveAuthConfig(import.meta.env, appOrigin),
    apiBaseUrl: configuredApiBaseUrl ?? (isProduction ? null : 'http://localhost:5100')
  }
};
